module.exports = __webpack_public_path__ + "img/gallagher-globe-logo-flat.e09b1256.svg";